import { module } from 'modujs'
import { CUSTOM_EVENT } from '../config'
import { positiveModulo } from '../utils/maths'
import { gsap } from '../lib/gsap'

export default class Header extends module {

    static get settings() {
        return {
            CLASS_OPEN: 'is-open',
            CLASS_ACTIVE_ITEM: 'is-current',
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$items = Array.from(this.$('item'))
        this.$links = Array.from(this.$('link'))
        this.linksLength = this.$links.length
        this.$toggler = this.$('toggler')?.[0]
        this.$togglerLabel = this.$('togglerLabel')?.[0]
        this.$indicator = this.$('indicator')[0]

        // Vars
        this.isOpen = false
        this.$hoverItem = null

        // Events
        this.events = {
            click: {
                'toggler': 'toggle',
            },
            mouseenter: {
                'item': 'onItemMouseEnter',
            },
            mouseleave: {
                'nav': 'onNavMouseLeave',
            }
        }
    }

    init() {
        // Default aitem active state
        this.onNavMouseLeave()

        // Events
        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind = () => this.resize())
        document.addEventListener('keydown', this.keydownBind = e => this.keydown(e))
    }

    keydown(e) {
        const key = e.key

        if(key == 'Escape') {
            this.close()
        } else if(key == 'ArrowDown') {
            e.preventDefault()
            this.setFocus(1)
        } else if(key == 'ArrowUp') {
            e.preventDefault()
            this.setFocus(-1)
        }
    }

    resize() {
        if(this.$hoverItem) {
            this.onItemMouseEnter({ curTarget: this.$hoverItem })
        } else {
            this.onNavMouseLeave()
        }
    }

    open() {
        if(this.isOpen) {
            return
        }

        this.isOpen = true
        this.$toggler.setAttribute('aria-expanded', 'true')
        this.$togglerLabel.innerHTML = 'Close'

        // Open menu modal
        this.call('open', null, 'ModalMenu')

        // Focus current item
        let focusableIndex = Math.max(0, this.$items.findIndex($item => $item.classList.contains(Header.settings.CLASS_ACTIVE_ITEM)))
        const focusable = this.$links[focusableIndex]
        focusable.focus();

        // Add open class to header
        this.$el.classList.add(Header.settings.CLASS_OPEN)
    }

    close() {
        if(!this.isOpen) {
            return
        }

        this.isOpen = false
        this.$toggler.setAttribute('aria-expanded', 'false')
        this.$togglerLabel.innerHTML = 'Menu'

        // Close menu modal
        this.call('close', null, 'ModalMenu')

        // Remove open class to header
        this.$el.classList.remove(Header.settings.CLASS_OPEN)
    }

    toggle() {
        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    onItemMouseEnter(e) {
        gsap.to(this.$indicator, {
            y: e.curTarget.offsetTop,
        })

        this.$hoverItem = e.curTarget
    }

    onNavMouseLeave() {
        const $currentItem = this.$items.find($item => $item.classList.contains(Header.settings.CLASS_ACTIVE_ITEM))

        if($currentItem) {
            gsap.to(this.$indicator, {
                y: $currentItem.offsetTop
            })
        }

        this.$hoverItem = null
    }

    setFocus(index=1) {
        if(!this.isOpen) {
            return
        }

        const $activeElement = document.activeElement

        const activeElementIndex = this.$links.findIndex(link => link === $activeElement)
        const newIndex = positiveModulo(activeElementIndex + index, this.linksLength)

        this.$links[newIndex]?.focus()
    }

    destroy() {
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind)
        document.removeEventListener('keydown', this.keydownBind)
    }
}
